<div class="inputs-container" *transloco="let t">
  <mat-form-field class="form-field" color="accent" hideRequiredMarker="true">
    <mat-label>{{t('longitude')}}</mat-label>
    <input matInput type="number" [ngModel]="lng()" (ngModelChange)="lng.set($event)" />
  </mat-form-field>
  <mat-form-field class="form-field" color="accent" hideRequiredMarker="true">
    <mat-label>{{t('latitude')}}</mat-label>
    <input matInput type="number" [ngModel]="lat()" (ngModelChange)="lat.set($event)" />
  </mat-form-field>
</div>
